//#region src/domain/logo/logo.ts
var LogoType = /* @__PURE__ */ function(LogoType) {
	LogoType["Vana"] = "vana";
	LogoType["VanaCard"] = "vana_card";
	LogoType["VanaCardBlue"] = "vana_card_blue";
	LogoType["VanaCardBlueDark"] = "vana_card_blue_dark";
	LogoType["VanaSquare"] = "vana_square";
	return LogoType;
}({});
//#endregion
export { LogoType };

//# sourceMappingURL=logo.js.map